var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import cls from 'classnames';
import './style/index.scss';
/**
 * @author sayll
 * @version 0.0.1
 */
export default class Accordion extends React.PureComponent {
    constructor(props) {
        super(props);
        this._selectedIndex = this.props.selectedIndex;
        // 处理children，为其赋值默认的提交事件，及保存所有 ref
        this.cloneChildren = (children, refs) => {
            return Array.isArray(children)
                ? children.map((ele, key) => ele
                    ? React.cloneElement(ele, {
                        key,
                        ref: refs[key],
                        collapsed: !~this.selectedIndex.indexOf(key),
                        collapsable: false,
                        onClick: (...props) => {
                            if (!this.props.multiply) {
                                this.selectedIndex = this.selectedIndex[0] === key ? [] : [key];
                            }
                            else {
                                const index = this.selectedIndex.indexOf(key);
                                const isActive = index > -1;
                                if (isActive) {
                                    this.selectedIndex.splice(index, 1);
                                }
                                else {
                                    this.selectedIndex.push(key);
                                }
                                this.selectedIndex = this.selectedIndex;
                            }
                            ele.props.onClick && ele.props.onClick(...props);
                        }
                    })
                    : ele)
                : [children];
        };
        this.state = { selectedIndex: props.selectedIndex };
    }
    render() {
        const _a = this.props, { prefixCls, className, children, multiply, selectedIndex, onCollapseChange } = _a, resetProps = __rest(_a, ["prefixCls", "className", "children", "multiply", "selectedIndex", "onCollapseChange"]);
        return (<div className={cls(prefixCls, className)} {...resetProps}>
        {this.panels}
      </div>);
    }
    getSnapshotBeforeUpdate(prevProps) {
        if (prevProps.selectedIndex !== this.props.selectedIndex) {
            this.selectedIndex = this.props.selectedIndex;
        }
        return null;
    }
    get elem() {
        return this;
    }
    /**
     * 选中的索引
     * */
    get selectedIndex() {
        return this._selectedIndex;
    }
    set selectedIndex(index) {
        const { onCollapseChange } = this.props;
        this._selectedIndex = index;
        this.refList.forEach((ref, key) => {
            ref.current.collapsed = !~index.indexOf(key);
        });
        onCollapseChange && onCollapseChange(index, this);
    }
    /**
     * 获取所有面板实例
     * */
    get panels() {
        const { children: cld } = this.props;
        // 如果默认非 Panel 组件时，存在兼容问题，有待优化。
        this.refList = Array.isArray(cld) ? cld.map(() => React.createRef()) : [];
        return this.cloneChildren(cld, this.refList);
    }
}
Accordion.defaultProps = {
    prefixCls: 'x-accordion',
    multiply: false,
    selectedIndex: []
};
